/* eslint-disable max-len */
import { createGlobalStyle } from 'styled-components'
import * as C from 'colorConstants'
import { QCS_PALETTE } from 'constants/qcsTheme'
import { getColorAnalytics } from './globalStylesHelper'

const GlobalStyle = createGlobalStyle`
  a {
    color: var(--color-text-link);
  }
  ::placeholder {
    color: var(--color-text-placeholder);
  }
  :root {

    /*
     * Careco design-system tokens for organisation home screens.
     * Literal values — not aliased onto legacy --color-* variables.
     */
    --careco-bg: #F6F9FD;
    --careco-surface: #FFFFFF;
    --careco-primary: #2A90CB;
    --careco-primary-hover: #227DB2;
    --careco-primary-light: #E3F5FF;
    --careco-nav-active: #0090CC;
    --careco-nav-bg: #1B9CD8;
    --careco-nav-bg-2: #1587BE;
    --careco-nav-item-inactive: rgba(255, 255, 255, 0.82);
    --careco-nav-item-active-bg: rgba(255, 255, 255, 0.24);
    --careco-row-default: #F7FAFE;
    --careco-row-alt: #E8F4FC;
    --careco-text-primary: #2E2E32;
    --careco-text-secondary: #616581;
    --careco-text-muted: #888888;
    --careco-icon-default: #616581;
    --careco-border: #E2E8F0;
    --careco-divider: #EBEBEB;
    --careco-placeholder: #F5F5F5;
    --careco-success: #489B00;
    --careco-success-light: #EAF8DD;
    --careco-error: #BA0000;
    --careco-error-light: #FBE7E7;
    --careco-status-inactive: #A5691B;
    --careco-status-inactive-light: #FAF1E4;
    --careco-chart-active: #4FCB8F;
    --careco-chart-inactive: #F79E9E;
    --careco-grid-line: #EFF3F8;
    --careco-accent-ask: #E85D8A;

    --careco-shadow-card: 0 2px 10px 2px rgba(110, 110, 110, 0.06);
    --careco-shadow-navigation: 0 4px 4px 3px rgba(110, 110, 110, 0.06);
    --careco-shadow-overlay: 0 2px 10px 0 rgba(0, 0, 0, 0.10);
    --careco-shadow-tooltip: 4px 4px 29px rgba(19, 69, 186, 0.086);

    --careco-rounded-none: 0px;
    --careco-rounded-sm: 8px;
    --careco-rounded-md: 12px;
    --careco-rounded-lg: 20px;
    --careco-rounded-pill: 999px;

    --careco-space-xxs: 4px;
    --careco-space-xs: 8px;
    --careco-space-sm: 12px;
    --careco-space-md: 16px;
    --careco-space-lg: 20px;
    --careco-space-xl: 24px;
    --careco-space-xxl: 28px;
    --careco-space-section: 48px;

    --careco-font: 'Lato', 'Segoe UI', -apple-system, Helvetica, Arial, sans-serif;

    //general colors
    --color-title: rgb(${C.COLOR_TITLE || '217, 217, 217'});
    --color-text-primary: rgb(${C.COLOR_TEXT_PRIMARY || '58, 63, 98'});
    --color-text-secondary: rgb(${C.COLOR_TEXT_SECONDARY || '97, 101, 129'});
    --color-text-placeholder: rgb(${C.COLOR_TEXT_PLACEHOLDER || '172, 176, 192'});
    --color-text-error: rgb(${C.COLOR_TEXT_ERROR || '255, 98, 76'});
    --color-text-success: rgb(${C.COLOR_TEXT_SUCCESS || '32, 176, 56'});
    --color-text-link: rgb(${C.COLOR_TEXT_LINK || '13, 60, 171'});
    --color-input-stroke: rgb(${C.COLOR_INPUT_STROKE || '235, 235, 239'});
    --color-disabled-fill: rgb(${C.COLOR_DISABLED_FILL || '172, 176, 192'});
    --color-action-disabled-bg: rgb(245, 245, 245);
    --color-action-disabled-text: rgb(155, 155, 155);
    --color-breadcrumb-blue:rgb(227, 245, 255);
    --color-text-gray:rgb(102, 112, 133); 
    --color-text-dark:rgb(43, 43, 43);
    --color-border-primary:rgb(199, 199, 199); 
    --color-text-blue:rgb(34, 140, 184);
    --color-text-form-label:rgb(46, 46, 50);
    --color-text-placeholder:rgb(136, 136, 136);
    --color-text-expiry: rgb(21, 72, 102);

    //primary colors
    --color-primary: ${C.COLOR_PRIMARY || '0, 160, 227'};

    --color-button-primary: rgb(${C.COLOR_BUTTON_PRIMARY ? `${C.COLOR_BUTTON_PRIMARY}` : 'var(--color-primary)'});
    --color-general-ui: rgb(${C.COLOR_GENERAL_UI ? `${C.COLOR_GENERAL_UI}` : 'var(--color-primary)'});
    --color-sidebar: rgb(${C.COLOR_SIDEBAR ? `${C.COLOR_SIDEBAR}` : 'var(--color-primary)'});
    /* Legacy / misspelled aliases used by older Service Users styles — follow --color-primary. */
    --color-primary-button-primary: rgb(var(--color-primary));
    --White-label-color-primary: rgb(var(--color-primary));

    --color-analytics-r: ${getColorAnalytics().R};
    --color-analytics-g: ${getColorAnalytics().G};
    --color-analytics-b: ${getColorAnalytics().B};
    --color-analytics: rgb(${C.COLOR_ANALYTICS ? `${C.COLOR_ANALYTICS}` : 'var(--color-primary)'});

    --color-primary-6: rgba(var(--color-primary), 0.06);
    --color-primary-10: rgba(var(--color-primary), 0.1);
    --color-primary-20: rgba(var(--color-primary), 0.2);
    --color-primary-32: rgba(var(--color-primary), 0.32);
    --color-primary-40: rgba(var(--color-primary), 0.4);

    --color-table-row-primary: ${C.COLOR_TABLE_ROW_PRIMARY ? `rgba(${C.COLOR_TABLE_ROW_PRIMARY})` : 'var(--color-primary-6)'
  };
    --color-hover-overlay-primary: ${C.COLOR_HOVER_OVERLAY_PRIMARY ? `rgba(${C.COLOR_HOVER_OVERLAY_PRIMARY})` : 'var(--color-primary-10)'
  };
    --color-badge-primary: ${C.COLOR_BADGE_PRIMARY ? `rgba(${C.COLOR_BADGE_PRIMARY})` : 'var(--color-primary-20)'};
    --color-pressed-overlay-primary: ${C.COLOR_PRESSED_OVERLAY_PRIMARY ? `rgba(${C.COLOR_PRESSED_OVERLAY_PRIMARY})` : 'var(--color-primary-32)'
  };
    --color-shadow-login-primary: ${C.COLOR_SHADOW_LOGIN_PRIMARY ? `rgba(${C.COLOR_SHADOW_LOGIN_PRIMARY})` : 'var(--color-primary-40)'
  };

    //secondary colors
    --color-secondary: ${C.COLOR_SECONDARY || '34, 140, 184'};

    --color-button-secondary: rgb(${C.COLOR_BUTTON_SECONDARY ? `${C.COLOR_BUTTON_SECONDARY}` : 'var(--color-secondary)'
  });

    --color-secondary-10: rgba(var(--color-secondary), 0.1);
    --color-secondary-32: rgba(var(--color-secondary), 0.32);

    --color-hover-overlay-secondary: ${C.COLOR_HOVER_OVERLAY_SECONDARY ? `rgba(${C.COLOR_HOVER_OVERLAY_SECONDARY})` : 'var(--color-secondary-10)'
  };
    --color-pressed-overlay-secondary: ${C.COLOR_PRESSED_OVERLAY_SECONDARY ? `rgba(${C.COLOR_PRESSED_OVERLAY_SECONDARY})` : 'var(--color-secondary-32)'
  };

    //light colors
    --color-light: ${C.COLOR_LIGHT || '255, 255, 255'};

    --color-text-on-primary: rgb(${C.COLOR_TEXT_ON_PRIMARY ? `${C.COLOR_TEXT_ON_PRIMARY}` : 'var(--color-light)'});
    --color-text-on-secondary: rgb(${C.COLOR_TEXT_ON_SECONDARY ? `${C.COLOR_TEXT_ON_SECONDARY}` : 'var(--color-light)'
  });

    --color-light-8: rgba(var(--color-light), 0.08);
    --color-light-32: rgba(var(--color-light), 0.32);
    --color-light-40: rgba(var(--color-light), 0.4);

    --color-hover-overlay-light: ${C.COLOR_HOVER_OVERLAY_LIGHT ? `rgba(${C.COLOR_HOVER_OVERLAY_LIGHT})` : 'var(--color-light-8)'
  };
    --color-pressed-overlay-light: ${C.COLOR_PRESSED_OVERLAY_LIGHT ? `rgba(${C.COLOR_PRESSED_OVERLAY_LIGHT})` : 'var(--color-light-32)'
  };

    //dark colors
    --color-dark: ${C.COLOR_DARK || '0, 0, 0'};

    --color-dark-10: rgba(var(--color-dark), 0.1);

    --color-hover-overlay-dark: ${C.COLOR_HOVER_OVERLAY_DARK ? `rgba(${C.COLOR_HOVER_OVERLAY_DARK})` : 'var(--color-dark-10)'
  };
    
    //default colors
    --color-white: rgb(255, 255, 255);
    --color-egg-white: rgb(254, 242, 189);
    --color-river-bed: rgb(70, 73, 96);
    --color-brandeis-blue: rgb(13, 110, 253);
    --color-peach-schnapps: rgb(255, 220, 216);
    --color-half-dutch-white: rgb(255, 248, 219);
    --color-tropical-blue: rgb(212, 225, 255);
    --color-light-peach: rgb(255, 216, 170);
    --color-peppermint: rgb(229, 248, 226);
    --color-pale-sky: rgb(109, 118, 134);
    --color-mine-shaft: rgb(57, 57, 57);
    --color-platinum: rgb(229, 229, 229);
    --color-periwinkle: rgb(202, 223, 255);
    --color-hawkes-lue: rgb(238, 245, 254);
    --color-selago-grey: rgb(247, 250, 254);
    --color-shark-black: rgb(33, 37, 41);
    --color-athens-grey: rgb(250, 250, 251);
    --color-mischka-grey: rgb(215, 216, 223);
    --color-oxford-blue: rgb(53, 64, 82);
    --color-klein-blue: rgb(0, 48, 160);
    --color-gem-blue: rgb(59, 23, 162);
    --color-camarone-green: rgb(0, 100, 1);
    --color-malachite-green: rgb(17, 195, 20);
    --color-cinnamon-yellow: rgb(125, 68, 0);
    --color-tamarillo-red: rgb(162, 16, 16);
    --color-coral-red: rgb(255, 98, 76);
    --color-spun-pearl-grey: rgb(176, 178, 192);
    --color-ghost-grey: rgb(199, 202, 214);
    --color-issabeline-grey: rgb(235, 235, 235);
    --color-hawkes-blue: rgb(230, 246, 252);
    /* Pending-action "Review" chip — CareBrain lilac; remapped under QCS. */
    --color-badge-review: #F2EDFC;
    --color-dark-gray: rgb(130, 130, 130);
    --color-charcoal: rgb(51,51,51);
    --color-text-black: rgba(46, 46, 50, 1);
  }

  :root[data-brand='qcs'] {
    --careco-bg: ${QCS_PALETTE.bg};
    --careco-primary: ${QCS_PALETTE.primary};
    --careco-primary-hover: ${QCS_PALETTE.primaryHover};
    --careco-primary-light: ${QCS_PALETTE.primaryLight};
    --careco-nav-active: ${QCS_PALETTE.navActive};
    --careco-nav-bg: ${QCS_PALETTE.navBg};
    --careco-nav-bg-2: ${QCS_PALETTE.navBg2};
    --careco-nav-item-inactive: ${QCS_PALETTE.navItemInactive};
    --careco-nav-item-active-bg: ${QCS_PALETTE.navItemActiveBg};
    --careco-row-default: ${QCS_PALETTE.rowDefault};
    --careco-row-alt: ${QCS_PALETTE.rowAlt};
    --careco-border: ${QCS_PALETTE.border};
    --careco-divider: ${QCS_PALETTE.divider};
    --careco-status-inactive: ${QCS_PALETTE.statusInactive};
    --careco-status-inactive-light: ${QCS_PALETTE.statusInactiveLight};
    --careco-success: ${QCS_PALETTE.success};
    --careco-success-light: ${QCS_PALETTE.successLight};
    --careco-error: ${QCS_PALETTE.error};
    --careco-error-light: ${QCS_PALETTE.errorLight};
    --careco-shadow-tooltip: 4px 4px 29px rgba(15, 61, 60, 0.12);
    --color-primary: ${QCS_PALETTE.primaryRgb};
    /* Bridge CareBrain semantic blues onto the QCS pine palette so shared
       uiKit (stepper, breadcrumbs, selects, submenu hover) follows brand
       without per-screen forks. Absent on CareBrain :root → unchanged. */
    --color-text-blue: ${QCS_PALETTE.primary};
    --color-secondary: ${QCS_PALETTE.primaryRgb};
    --color-button-primary: ${QCS_PALETTE.primary};
    --color-button-secondary: ${QCS_PALETTE.primary};
    --color-general-ui: ${QCS_PALETTE.primary};
    --color-breadcrumb-blue: ${QCS_PALETTE.primaryLight};
    --color-hawkes-blue: ${QCS_PALETTE.primaryLight};
    --color-badge-review: ${QCS_PALETTE.primaryLight};
    --color-text-expiry: ${QCS_PALETTE.primary};
  }
`

export default GlobalStyle
